import * as React from "react";

const TriggerIcon = (props: { color: string }): JSX.Element => {
    return (
        <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.81744 0.904373C5.97848 0.733727 6.2248 0.665565 6.45465 0.735916C6.71721 0.81639 6.89654 1.05861 6.89654 1.33325V7.23331H9.16705C9.39686 7.23331 9.60812 7.3598 9.71718 7.56209C9.81254 7.73905 9.81614 7.9493 9.73101 8.12768L9.6887 8.20255L4.11008 16.6767C3.95829 16.9072 3.67303 17.0114 3.40859 16.9322C3.14412 16.853 2.96262 16.6093 2.96262 16.3332V10.0092H0.833716C0.60254 10.0092 0.390423 9.88131 0.281958 9.67716C0.17353 9.47302 0.186757 9.22581 0.316138 9.03426L5.75396 0.983312L5.81744 0.904373ZM2.00966 8.75919H3.58762C3.9328 8.75919 4.21262 9.03901 4.21262 9.38419V14.2475L8.00819 8.48331H6.27154C5.92638 8.4833 5.64654 8.20348 5.64654 7.85831V3.37426L2.00966 8.75919Z"
                fill={props.color}
            />
        </svg>
    );
};

export default TriggerIcon;
